exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SanalPos[data-v-c2987b92]{padding:10px}.SanalPos h5[data-v-c2987b92]{font-size:16px}.SanalPos h6[data-v-c2987b92]{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2987b92","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Vezne/ManuelSanalPos.vue
// module id = 505
// module chunks = 0